import React from "react";
import {
  Box,
  Step,
  StepIcon,
  StepIndicator,
  StepNumber,
  StepSeparator,
  StepStatus,
  StepTitle,
} from "@chakra-ui/react";
import type {IStepperStep} from "../models/interfaces/steperItem.interface.ts";

interface StepperStepProps {
  readonly step: IStepperStep;
  readonly isVertical?: boolean;
  readonly isCompleted?: boolean;
  readonly isActive?: boolean;
}

const StepperStep: React.FC<StepperStepProps> = (
  {
    step,
    isVertical,
    isCompleted,
    isActive,
  }: StepperStepProps) => {
  return (
    <Step aria-current={isActive ? "step" : undefined}>
      <StepIndicator
        borderColor="brandPurple.500"
        bg="brandPurple.500"
        _active={{bg: "brandPurple.500"}}
      >
        <StepStatus
          complete={
            <Box
              w="100%"
              h="100%"
              borderRadius="full"
              bg="brandPurple.500"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <StepIcon color="white"/>
            </Box>
          }
          incomplete={<StepNumber color="white"/>}
          active={<StepNumber color="white"/>}
        />
      </StepIndicator>

      <Box>
        <StepTitle fontSize="small">{step.title}</StepTitle>
      </Box>

      <StepSeparator>
        <Box
          sx={{
            height: isVertical ? "100%" : "2px",
            width: isVertical ? "2px" : "100%",
            flex: 1,
            backgroundColor: isCompleted ? "brandPurple.500" : "white",
            borderRadius: "1px",
          }}
        />
      </StepSeparator>
    </Step>
  );
};

export default StepperStep;
